export const JOBS = [
  {
    title: "OB/GYN SURGERY",
    category: "Medical",
    type: "Full Time",
    location: "United States",
    slug: "ob-gyn-surgery",
  },

  {
    title: "ORTHOPEDIC SURGERY",
    category: "Surgical",
    type: "Full Time",
    location: "United States",
    slug: "orthopedic-surgery",
  },

  {
    title: "NEUROSPINAL SURGERY",
    category: "Surgical",
    type: "Full Time",
    location: "United States",
    slug: "neurospinal-surgery",
  },

  {
    title: "ROBOTIC SURGERY",
    category: "Medical",
    type: "Full Time",
    location: "United States",
    slug: "robotic-surgery",
  },

  {
    title: "CARDIOTHORACIC SURGERY",
    category: "Medical",
    type: "Full Time",
    location: "United States",
    slug: "cardiothoracic-surgery",
  },

  {
    title: "SURGICAL ASSISTANT",
    category: "Medical",
    type: "Full Time",
    location: "United States",
    slug: "surgical-assistant",
  },
];



// <==== AVAILABLE JOBS ====>

export const AVAILABLE_JOBS = {
  "ob-gyn-surgery": {
    title: "OB/GYN SURGERY",
    category: "Medical",
    type: "Full Time",
    location: "United States",

    list: [
      { li: "Experience in working in gynecological surgery" },
      { li: "Willingness to travel to other offices if/when needed" },
      { li: "Great customer service skills" },
      { li: "Effective written, verbal and electronic communication" },
      {
        li: "Ability to gain trust and respect of the doctors, practice managers, teams, and peers",
      },
      { li: "Excellent organizational and multi-tasking skills" },
      {
        li: "Ability to take initiative and exercise independent judgment, decision-making and problem-solving expertise",
      },
      { li: "Ability to maintain confidentiality" },
      { li: "Computer proficiency in Outlook, Word, Excel and PowerPoint" },
      { li: "Respect: We actively listen and seek to understand" },
    ],
  },

  "orthopedic-surgery": {
    title: "ORTHOPEDIC SURGERY",
    category: "Medical",
    type: "Full Time",
    location: "United States",

    list: [
      { li: "Experience in working in Orthopedic Surgery" },
      { li: "Willingness to travel to other offices if/when needed" },
      { li: "Great customer service skills" },
      { li: "Effective written, verbal and electronic communication" },
      {
        li: "Ability to gain trust and respect of the doctors, practice managers, teams, and peers",
      },
      { li: "Excellent organizational and multi-tasking skills" },
      {
        li: "Ability to take initiative and exercise independent judgment, decision-making and problem-solving expertise",
      },
      { li: "Ability to maintain confidentiality" },
      { li: "Computer proficiency in Outlook, Word, Excel and PowerPoint" },
      { li: "Respect: We actively listen and seek to understand" },
    ],
  },

  "neurospinal-surgery": {
    title: "NEUROSPINAL SURGERY",
    category: "Medical",
    type: "Full Time",
    location: "United States",

    list: [
      { li: "Experience in working in Neurospinal Surgery" },
      { li: "Willingness to travel to other offices if/when needed" },
      { li: "Great customer service skills" },
      { li: "Effective written, verbal and electronic communication" },
      {
        li: "Ability to gain trust and respect of the doctors, practice managers, teams, and peers",
      },
      { li: "Excellent organizational and multi-tasking skills" },
      {
        li: "Ability to take initiative and exercise independent judgment, decision-making and problem-solving expertise",
      },
      { li: "Ability to maintain confidentiality" },
      { li: "Computer proficiency in Outlook, Word, Excel and PowerPoint" },
      { li: "Respect: We actively listen and seek to understand" },
    ],
  },
  "robotic-surgery": {
    title: "ROBOTIC SURGERY",
    category: "Medical",
    type: "Full Time",
    location: "United States",

    list: [
      { li: "Experience in working in Robotic Surgery" },
      { li: "Willingness to travel to other offices if/when needed" },
      { li: "Great customer service skills" },
      { li: "Effective written, verbal and electronic communication" },
      {
        li: "Ability to gain trust and respect of the doctors, practice managers, teams, and peers",
      },
      { li: "Excellent organizational and multi-tasking skills" },
      {
        li: "Ability to take initiative and exercise independent judgment, decision-making and problem-solving expertise",
      },
      { li: "Ability to maintain confidentiality" },
      { li: "Computer proficiency in Outlook, Word, Excel and PowerPoint" },
      { li: "Respect: We actively listen and seek to understand" },
    ],
  },
  "cardiothoracic-surgery": {
    title: "CARDIOTHORACIC SURGERY",
    category: "Medical",
    type: "Full Time",
    location: "United States",

    list: [
      { li: "Experience in working in Cardiac and/or Thoracic Surgery" },
      { li: "Willingness to travel to other offices if/when needed" },
      { li: "Great customer service skills" },
      { li: "Effective written, verbal and electronic communication" },
      {
        li: "Ability to gain trust and respect of the doctors, practice managers, teams, and peers",
      },
      { li: "Excellent organizational and multi-tasking skills" },
      {
        li: "Ability to take initiative and exercise independent judgment, decision-making and problem-solving expertise",
      },
      { li: "Ability to maintain confidentiality" },
      { li: "Computer proficiency in Outlook, Word, Excel and PowerPoint" },
      { li: "Respect: We actively listen and seek to understand" },
    ],
  },
  "surgical-assistant": {
    title: "SURGICAL ASSISTANT",
    category: "Medical",
    type: "Full Time",
    location: "United States",

    list: [
      { li: "Experience in working in Surgical Setting" },
      { li: "Willingness to travel to other offices if/when needed" },
      { li: "Great customer service skills" },
      { li: "Effective written, verbal and electronic communication" },
      {
        li: "Ability to gain trust and respect of the doctors, practice managers, teams, and peers",
      },
      { li: "Excellent organizational and multi-tasking skills" },
      {
        li: "Ability to take initiative and exercise independent judgment, decision-making and problem-solving expertise",
      },
      { li: "Ability to maintain confidentiality" },
      { li: "Computer proficiency in Outlook, Word, Excel and PowerPoint" },
      { li: "Respect: We actively listen and seek to understand" },
    ],
  },
};
